import type { ParticipantFieldGroup } from '@piccolohealth/pbs-common';
import { ChakraV3, Empty } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { FormSection } from '../../components/forms/FormSection';
import { FormStack } from '../../components/forms/FormStack';
import { HookedFieldControl } from '../../components/forms/HookedFieldControl';
import { HookedFormField } from '../../components/forms/HookedFormField';
import { FormErrorsAlert } from '../../components/generic/FormErrorsAlert';
import { gridItemSize } from '../../utils/gridItemSize';

interface Props {
  fieldGroup: ParticipantFieldGroup;
  fieldGroupIndex: number;
  isDisabled?: boolean;
}

export const ParticipantFormFieldGroup = (props: Props) => {
  const { fieldGroup, fieldGroupIndex, isDisabled } = props;

  const content = P.run(() => {
    if (P.isEmpty(fieldGroup.fields)) {
      return <Empty title='No fields found' />;
    }

    return (
      <FormStack>
        <FormErrorsAlert />
        <FormSection heading={fieldGroup.template.name}>
          <ChakraV3.Grid w='full' templateColumns='repeat(2, 1fr)' gap={4}>
            {fieldGroup.fields.map((field, fieldIndex) => (
              <ChakraV3.GridItem key={field.id} colSpan={gridItemSize(field.template.type)}>
                <HookedFormField
                  key={field.id}
                  name={`fieldGroups.${fieldGroupIndex}.fields.${fieldIndex}.value`}
                  label={field.template.name}
                  disabled={isDisabled}
                >
                  <HookedFieldControl
                    name={`fieldGroups.${fieldGroupIndex}.fields.${fieldIndex}.value`}
                    type={field.template.type}
                    attributes={field.template.attributes}
                    isDisabled={isDisabled}
                  />
                </HookedFormField>
              </ChakraV3.GridItem>
            ))}
          </ChakraV3.Grid>
        </FormSection>
      </FormStack>
    );
  });

  return (
    <ChakraV3.Tabs.Content
      justifyContent='center'
      value={`${fieldGroup.template.name}-${fieldGroup.template.index}`}
    >
      {content}
    </ChakraV3.Tabs.Content>
  );
};
